import React from 'react'
import CustomCursor from '../Global/Cursor';
import Preloader from '../Global/Preloader'
import Header from '../../components/Global/Header1';
import PageInear from '../MenContact/PageInear';
import Contact from '../MenContact/Contact';
import Locations from '../MenContact/Locations';
import Map from '../MenContact/Map';
import Cta from '../MenContact/Cta';
import Footer from '../Global/Footer1';
import GoToTop from '../Global/GoToTop';


const Main = () => {
    return (
        <>
            <CustomCursor />
            <Preloader />
            <Header />
            <PageInear />
            <Contact />
            <Locations />
            <Map />
            <Cta />
            <Footer />
            <GoToTop />

        </>
    )
}

export default Main
